<template>
  <div class="references-plugin">
    <popup
      :title="$t('plugins.refs.creationDialog.title')"
      ref="referenceCreationDialog"
      class="references-plugin__creation-dialog"
    >
      <r-form ref="popupForm"></r-form>
      <template v-slot:buttons>
        <btn icon="times" @click="$refs.referenceCreationDialog.close()">{{
          $t("btn.cancel")
        }}</btn>
        <btn icon="save" @click="createRefferal" color="green">{{
          $t("btn.create")
        }}</btn>
      </template>
    </popup>

    <popup
      :title="$t('plugins.refs.deleteDialog.title')"
      ref="referenceDeleteDialog"
      v-if="selected"
    >
      <p>
        {{ $t("plugins.refs.deleteDialog.text") }}
        <b>"{{ selected.name }}"</b>?
      </p>
      <template v-slot:buttons>
        <btn icon="times" @click="$refs.referenceDeleteDialog.close()">{{
          $t("btn.cancel")
        }}</btn>
        <btn icon="trash" @click="deleteRefferal" color="red">{{
          $t("btn.delete")
        }}</btn>
      </template>
    </popup>

    <div class="references-plugin__sidebar">
      <div class="references-plugin__items">
        <div
          class="references-plugin__item"
          v-for="(item, index) in refferals"
          :key="index"
        >
          <short-card
            v-model="refferals[index]"
            @selected="setSelected(item)"
            :isSelected="isSelected(item)"
          >
            <div>{{ item.name }}</div>
            <div>{{ $store.getters.flowBlock(item.targetUuid).name }}</div>
          </short-card>
        </div>
      </div>
      <div
        class="references-plugin__create"
        @click="$refs.referenceCreationDialog.open()"
      >
        {{ $t("btn.create") }}
      </div>
      <div class="references-plugin__sidebar-menu"></div>
    </div>
    <div class="references-plugin__editor editor">
      <div v-if="selected" class="references-plugin__top-buttons">
        <h2>{{ selected.name }}</h2>
        <div>
          <btn
            icon="trash"
            style="margin-right: 12px"
            color="red"
            @click="$refs.referenceDeleteDialog.open()"
            >{{ $t("btn.delete") }}</btn
          >
          <btn icon="save" @click="saveChanges">{{ $t("btn.save") }}</btn>
        </div>
      </div>
      <div>
        <r-form v-show="selected" ref="form"></r-form>
      </div>
    </div>
  </div>
</template>

<script>
import Form from "../components/CreationForm.vue";
import axios from "@/axios";
export default {
  data() {
    return {
      refferals: [],
      selected: null,
    };
  },
  components: {
    "r-form": Form,
  },
  methods: {
    wrapRefferalRow(row) {
      row.targetUuid = row.block_uuid;
      row.useRegexp = row.use_regexp;

      if (row.data.flags) {
        row.regexp = row.data;
        row.textMatch = row.textMatch || {
          pattern: "match me",
          caseSensitive: false,
        };
      } else {
        row.regexp = {
          pattern: "match me",
          flags: {
            g: false,
            m: false,
            i: false,
          },
        };

        row.textMatch = row.data;
      }

      delete row.use_regexp;
      delete row.data;
      delete row.block_uuid;
    },

    async createRefferal() {
      try {
        const formData = this.$refs.popupForm.getData();
        if (formData.useRegexp) delete formData.textMatch;
        else delete formData.regexp;
        const createReq = await axios.post(
          "/api/plugin/refs/reactions/create",
          formData
        );
        const createdRow = createReq.data.created;
        this.wrapRefferalRow(createdRow);
        this.$refs.popupForm.reset();
        this.refferals.push(createdRow);
      } catch (e) {
        this.notify("error", "plugins.refs.error.create");
        console.error(e);
      } finally {
        this.$refs.referenceCreationDialog.close();
      }
    },

    isSelected(item) {
      if (item === this.selected) return true;
    },

    setSelected(item) {
      this.selected = item;
      this.$refs.form.load(JSON.parse(JSON.stringify(this.selected)));
    },

    async saveChanges() {
      try {
        const changed = this.$refs.form.getData();
        if (changed.useRegexp) delete changed.textMatch;
        else delete changed.regexp;
        const updateReq = await axios.put(
          "/api/plugin/refs/reactions/update",
          changed
        );
        const updated = updateReq.data.updated;
        this.wrapRefferalRow(updated);
        for (let i = 0; i < this.refferals.length; i++) {
          if (this.refferals[i].id === this.selected.id) {
            this.$set(this.refferals, i, updated);
            this.selected = updated;
            this.$refs.form.load(this.selected);
            break;
          }
        }
        this.notify("success", "plugins.refs.success.save");
      } catch (e) {
        this.notify("error", "plugins.refs.error.save");
        console.error(e);
      }
    },

    async deleteRefferal() {
      try {
        await axios.delete("/api/plugin/refs/reactions/delete", {
          data: { id: this.selected.id },
        });
        for (let i = 0; i < this.refferals.length; i++) {
          if (this.refferals[i].id === this.selected.id) {
            this.refferals.splice(i, 1);
            break;
          }
        }
        this.selected = null;
        this.notify("success", "plugins.refs.success.delete");
      } catch (e) {
        this.notify("error", "plugins.refs.error.delete");
        console.error(e);
      } finally {
        this.$refs.referenceDeleteDialog.close();
      }
    },
  },

  async created() {
    try {
      await this.$store.dispatch("loadFlowData", this);
      const listReq = await axios.get("/api/plugin/refs/reactions/list");
      for (const r of listReq.data.reactions) this.wrapRefferalRow(r);
      this.refferals = listReq.data.reactions;
    } catch (e) {
      this.notify("error", "plugins.refs.error.load");
      console.error(e);
    }
  },
};
</script>

<style lang="scss" scoped>
.references-plugin {
  display: flex;
  height: 100%;

  &__top-buttons {
    @include alignedFlex(space-between);
    padding: 15px 20px 15px 0;
  }

  &__sidebar {
    @include boxShadow(-2px, 0px, 15px, -13px, rgba(0, 0, 0, 0.75));
    background-color: $bgLightGrey;
    width: 20vw;
    max-width: 350px;
    min-width: 310px;
    height: 100%;
    display: flex;
    flex-direction: column;
    justify-content: space-between;
  }

  &__items {
    overflow-y: scroll;
    height: 92%;
  }

  &__item {
    width: 92%;
    margin: 10px auto 10px auto;
  }

  &__create {
    @include clickableText();
  }
}
</style>
